import { LOG_LEVEL_ORDER } from './constants';
const STORAGE_KEY = 'interlucent:logLevel';
let cached = null;
function readFromStorage() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        return v && v in LOG_LEVEL_ORDER ? v : null;
    }
    catch {
        return null;
    }
}
cached = readFromStorage();
/** Update log level -- persists to localStorage, takes effect immediately. */
export function setLogLevel(level) {
    cached = level;
    try {
        localStorage.setItem(STORAGE_KEY, level);
    }
    catch { /* sandboxed */ }
}
/** Clear override -- reverts to per-consumer fallback. */
export function clearLogLevel() {
    cached = null;
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch { /* sandboxed */ }
}
/**
 * Returns a ThresholdGetter that checks the global cached level first,
 * then falls back to the provided default.
 *
 * Fallback can be a static LogLevel or a dynamic ThresholdGetter
 * (e.g. for pixel-stream's attribute-driven logLevel).
 */
export function globalThreshold(fallback = 'info') {
    return () => cached ?? (typeof fallback === 'function' ? fallback() : fallback);
}
